import { StyledInputGroup } from "./style";

export default function InputGroup({ children }) {
  return <StyledInputGroup>{children}</StyledInputGroup>;
}
